<template>
  <div>
    <a-card>
      <template #title>
        <strong>
          <a-badge :status="statusDictionary[device.enabled ? 'ACTIVE' : 'INACTIVE'].badge"/>
          {{
            device.name
          }}</strong>
      </template>
      <template #extra>
        <a-dropdown placement="bottomRight">
          <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            <a-icon type="setting"/>
          </a>
          <a-menu slot="overlay" @click="menuClicked">
            <a-menu-item v-if="!device.enabled" key="activate">
              <a-icon key="check" type="check"/>
              Aktywuj
            </a-menu-item>
            <a-menu-item v-if="device.enabled" key="deactivate">
              <a-icon key="close" type="close"/>
              Deaktywuj
            </a-menu-item>
            <a-menu-item key="edit">
              <a-icon key="edit" type="edit"/>
              Edytuj
            </a-menu-item>
            <a-menu-item key="vendor">
              <a-icon key="barcode" type="barcode"/>
              Odśwież producenta
            </a-menu-item>
            <a-menu-divider/>
            <a-sub-menu key="move">
              <span slot="title" style="padding-right: 8px">
                <a-icon type="logout"/>
                Zmień lokalizację
              </span>
              <a-menu-item v-for="dorm in dorms" :key="'moveTo:' + dorm.code" :disabled="device.activeLease && dorm.code === device.activeLease.dorm.code">
                {{ dorm.name }}
              </a-menu-item>
            </a-sub-menu>
            <a-menu-item key="owner">
              <a-icon key="user" type="user"/>
              Zmień właściciela
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>
      <a-row :gutter="[8, 8]">
        <!-- <a-col :span="24">
            <a-tag color="blue">D.S. Proton</a-tag>
        </a-col> -->
        <a-col :lg="12" :md="24" :sm="24" :xl="12" :xs="24" :xxl="6">
          <small style="display: block;">Adres MAC</small>
          {{ device.macAddress }}
        </a-col>
        <a-col v-if="device.activeLease" :lg="12" :md="24" :sm="24" :xl="12" :xs="24" :xxl="6">
          <small style="display: block;">Adres IP</small>
          {{ device.activeLease.ip }}
        </a-col>
        <a-col v-if="device.activeLease" :lg="12" :md="24" :sm="24" :xl="12" :xs="24" :xxl="6">
          <small style="display: block;">Lokalizacja</small>
          {{ device.activeLease.dorm.name }}
        </a-col>
        <a-col v-if="device.vendor" :lg="12" :md="24" :sm="24" :xl="12" :xs="24" :xxl="6">
          <small style="display: block;">Producent
            <a-tooltip>
              <template slot="title">
                Na podstawie adresu MAC
              </template>
              <a-icon type="question-circle"/>
            </a-tooltip>
          </small>
          {{ device.vendor ? device.vendor : '- brak -' }}
        </a-col>
        <a-col :lg="12" :md="24" :sm="24" :xl="12" :xs="24" :xxl="6">
          <small style="display: block;">Data rejestracji</small>
          {{ device.created | moment('HH:mm - DD.MM.YYYY') }} r.
        </a-col>
        <a-col :lg="12" :md="24" :sm="24" :xl="12" :xs="24" :xxl="6">
          <small style="display: block;">Ostatnio dostępne</small>
          {{ device.lastSeen | moment('HH:mm - DD.MM.YYYY') }} r.
        </a-col>
        <a-col v-if="device.deactivated" :lg="12" :md="24" :sm="24" :xl="12" :xs="24" :xxl="6">
          <small style="display: block;">Data deaktywacji</small>
          {{ device.deactivated | moment('HH:mm - DD.MM.YYYY') }} r.
        </a-col>
      </a-row>
    </a-card>
    <ChangeDeviceOwnerModal :show="changeOwnerModalVisible" :deviceUuid="device.deviceUuid" @close="changeOwnerModalVisible = false" @changedOwner="updateView"/>
  </div>
</template>

<script>

import httpClient from "@/utils/httpClient";
import ChangeDeviceOwnerModal from "@/components/account/ChangeDeviceOwnerModal.vue";

const statusDictionary = {
  "INACTIVE": {badge: "default", name: "Nieaktywny"},
  "ACTIVE": {badge: "success", name: "Aktywny"},
}

export default {
  name: "Device",
  components: {ChangeDeviceOwnerModal},
  props: {
    dorms: Array,
    device: {
      activeLease: {
        name: String,
        ip: String,
        dorm: {
          code: String,
          name: String
        }
      },
      created: Date,
      deactivated: Date,
      deviceUuid: String,
      enabled: Boolean,
      lastSeen: Date,
      name: String
    }
  },
  data() {
    return {
      statusDictionary,
      changeOwnerModalVisible: false
    }
  },
  methods: {
    menuClicked({key}) {
      if (key === 'activate') {
        this.activateDevice()
      } else if (key === 'deactivate') {
        this.deactivateDevice()
      } else if (key === 'vendor') {
        this.refreshVendor()
      } else if (key === 'owner') {
        this.changeOwnerModalVisible = true;
      } else if (key.startsWith('moveTo:')) {
        let dormCode = key.split(':')[1]
        this.moveDevice(dormCode)
      } else {
        this.$message.warning("Funkcjonalność w trakcie implementacji")
      }
    },

    activateDevice() {
      this.$message.loading({content: `Aktywowanie urządzenia ${this.device.name}...`, key: 'activation'});
      httpClient
          .put(`/admin/devices/${this.device.deviceUuid}/activate`)
          .then(() => {
            this.$message.success({content: `Urządzenie ${this.device.name} zostało aktywowane!`, key: 'activation'});
            this.$emit("updated");
          }).catch(() => {
        this.$message.error({content: `Wystąpił błąd z aktywacją ${this.device.name}!`, key: 'activation'});
      })
    },

    moveDevice(dormCode) {
      this.$message.loading({content: `Przenoszenie urządzenia ${this.device.name}...`, key: 'activation'});
      httpClient
          .put(`/admin/devices/${this.device.deviceUuid}/move/${dormCode}`)
          .then(() => {
            this.$message.success({content: `Urządzenie ${this.device.name} zostało przeniesione!`, key: 'activation'});
            this.$emit("updated");
          }).catch(() => {
        this.$message.error({content: `Wystąpił błąd z przeniesieniem ${this.device.name}!`, key: 'activation'});
      })
    },

    deactivateDevice() {
      this.$message.loading({content: `Deaktywowanie urządzenia ${this.device.name}...`, key: 'deactivation'});
      httpClient
          .put(`/admin/devices/${this.device.deviceUuid}/deactivate`)
          .then(() => {
            this.$message.success({content: `Urządzenie ${this.device.name} zostało deaktywowane!`, key: 'deactivation'});
            this.$emit("updated");
          }).catch(() => {
        this.$message.error({content: `Wystąpił błąd z deaktywacją ${this.device.name}!`, key: 'deactivation'});
      })
    },

    refreshVendor() {
      httpClient
          .put(`/admin/devices/${this.device.deviceUuid}/refresh-vendor`)
          .then(() => {
            this.$message.success({content: `Urządzenie ${this.device.name} zostało odświeżone!`, key: 'refreshVendor'});
            this.$emit("updated");
          }).catch(() => {
        this.$message.error({content: `Wystąpił błąd z odświeżeniem ${this.device.name}!`, key: 'refreshVendor'});
      })
    },

    updateView(event) {
      this.changeOwnerModalVisible = false;
      this.$emit("changedOwner", event);
    },
  }
}
</script>
